export default [
    {
        id: 1,
        name: 'Fruit & Vegetables',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/fruits-and-vegetables.svg',
        // backend not returning data for 111745, 200001- temporarily replaced with 112664 and 111493
        externalSkus: [118836, 114820, 114953, 118829, 112055, 111132],
        aisleFooter: 'farmers',
        items: [
            {
                id: 61946,
                externalSku: 118836,
                slug: 'kiwi-berries-44-oz',
                brand: '',
                name: 'Kiwi Berries, 4.4 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Kiwi berries are actually not berries at all\u2014they\u2019re just mini versions of full-size kiwis! They're about the size of a grape, look just like kiwis on the inside, and you can eat 'em whole. Ripen them at room temp and when their skin turns a darker green and gets a tad wrinkly, you'll know they're ready for snacking.",
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 4.99,
                price: 4.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: [],
                sourcingReason: 'Excess inventory',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8583_xs_2024-02-20_11-18-10.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8583_sm_2024-02-20_11-18-10.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8583_md_2024-02-20_11-18-10.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8583_lg_2024-02-20_11-18-10.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58067,
                externalSku: 114820,
                slug: 'organic-small-hass-avocados-5-6-ct',
                brand: '',
                name: 'Organic Small Hass Avocados, 5-6 Ct',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Whether you smash them on toast, top them with an egg, or make the world's best guac, you avoca-don't want to miss out on the creamy texture, nutty flavor, and easy-to-peel skin of these organic mini Hass avocados. They're not small\u2014they're fun-sized! (Each bag contains 5\u20136 mini avocados and weighs in around 1.75 lbs.)",
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 7.99,
                price: 5.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Organic'],
                sourcingReason: 'Too small/smaller',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_4229_xs_2024-04-02_20-49-50.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4229_sm_2024-04-02_20-49-50.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4229_md_2024-04-02_20-49-50.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4229_lg_2024-04-02_20-49-50.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 61980,
                externalSku: 114953,
                slug: 'organic-cara-cara-oranges-3-lbs',
                brand: '',
                name: 'Organic Cara Cara Oranges, 3 Lbs',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'The seedless Cara Cara is a medium-sized citrus fruit with minimal pith and an easy-to-peel rind, making it the perfect on-the-go snack. Whats really special is its deep orange peel and blood-orange interior.',
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 6.99,
                price: 5.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Organic'],
                sourcingReason: 'Slightly Scarred',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_4398_xs_2022-02-01_20-12-48.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4398_sm_2022-02-01_20-12-48.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4398_md_2022-02-01_20-12-48.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4398_lg_2022-02-01_20-12-48.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 62017,
                externalSku: 118829,
                slug: 'organic-kumquat-8-oz',
                brand: '',
                name: 'Organic Kumquat, 8 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Don\u2019t be fooled by their small size, kumquats are big on flavor. Specifically, mouth-puckeringly tart flavor. You eat the peel and all, so snack on them whole or slice up for salad. If you want to tamp down tartness, explore making marmalade, candying them, or roasting.  Organic Kumquat',
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 7.99,
                price: 6.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Organic'],
                sourcingReason: 'Mixed colors',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8576_xs_2024-02-20_11-14-50.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8576_sm_2024-02-20_11-14-50.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8576_md_2024-02-20_11-14-50.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8576_lg_2024-02-20_11-14-50.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 65844,
                externalSku: 112055,
                slug: 'organic-purple-sweet-potatoes',
                brand: null,
                name: 'Organic Purple Sweet Potatoes',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Purple sweet potatoes have a light purple skin and bright purple flesh. While they can be treated like an orange sweet potato, they\u2019re a little drier and denser, requiring longer baking times than their orange cousins.',
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 1.5,
                price: 2.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Organic'],
                sourcingReason: '',
                portion: 2,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_xs_2020-09-02_10-18-17.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_982_sm_2020-09-02_10-18-17.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_982_md_2020-09-02_10-18-17.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_982_lg_2020-09-02_10-18-17.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_xs__photo2_2021-12-06_10-54-50.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_sm__photo2_2021-12-06_10-54-50.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_md__photo2_2021-12-06_10-54-50.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_lg__photo2_2021-12-06_10-54-50.jpg',
                photoThreeExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_xs__photo3_2021-12-15_10-53-55.jpg',
                photoThreeSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_sm__photo3_2021-12-15_10-53-55.jpg',
                photoThreeMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_md__photo3_2021-12-15_10-53-55.jpg',
                photoThreeLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_982_lg__photo3_2021-12-15_10-53-55.jpg',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 65744,
                externalSku: 111132,
                slug: 'organic-broccoli-ninos-1-lb',
                brand: null,
                name: 'Organic Broccoli Ni\u00f1os, 1 Lb',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Not familiar with broccoli ni\u00f1os? That might be because they're not usually found in traditional grocery stores. Rather than leave them in the field, our growing partners at Lakeside Organics scoop up the tender florets that fall off the main broccoli stalk while it\u2019s being harvested and bundle them up for us to cut back on food waste. Mildly sweet in flavor, we like them raw paired with hummus or ranch dip, though they\u2019re deliciously tender when steamed for a side.",
                ingredients: null,
                isDrinksItem: false,
                l1TaxonomyName: 'Produce',
                hasMsrp: false,
                msrp: 4.99,
                price: 3.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Organic'],
                sourcingReason: '',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_xs_2024-04-16_16-15-09.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_38_sm_2024-04-16_16-15-09.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_38_md_2024-04-16_16-15-09.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_38_lg_2024-04-16_16-15-09.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_xs__photo2_2024-04-16_16-15-23.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_sm__photo2_2024-04-16_16-15-23.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_md__photo2_2024-04-16_16-15-23.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_lg__photo2_2024-04-16_16-15-23.jpg',
                photoThreeExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_xs__photo3_2021-12-13_11-17-32.jpg',
                photoThreeSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_sm__photo3_2021-12-13_11-17-32.jpg',
                photoThreeMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_md__photo3_2021-12-13_11-17-32.jpg',
                photoThreeLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_38_lg__photo3_2021-12-13_11-17-32.jpg',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
    {
        id: 2,
        name: 'Meat & Seafood',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/meat-and-seafood.svg',
        externalSkus: [113793, 118301, 118609, 114694, 117824, 117632],
        aisleFooter: 'upcycling-carousel',

        items: [
            {
                id: 60158,
                externalSku: 113793,
                slug: 'niman-ranch-bacon-ends-pieces-12-oz',
                brand: 'Niman Ranch',
                name: 'Bacon Ends & Pieces, 12 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: 0,
                desc: 'Niman Ranch, along with its network of U.S. family farmers and ranchers, raises livestock humanely and sustainably to deliver quality-tasting meat. We stepped in to save these uncured bacon ends and pieces: leftover bits that were too oddly-shaped and -sized to make the cut (but still taste just fine)! Fry them up (use a deep pan to avoid grease splatter) and add them to salads, omelettes, pastas, and more.\n\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.',
                ingredients:
                    'Pork Prepared With: Water, Salt, Turbinado Sugar, Cultured Celery Powder (Celery Powder, Sea Salt).',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 9.99,
                price: 5.29,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: 'Leftover Pieces',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_30002021-08-17_22-47-15.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_xs_2021-10-11_09-48-08.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_sm_2021-10-11_09-48-08.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_md_2021-10-11_09-48-08.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_lg_2021-10-11_09-48-08.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_xs__photo2_2021-08-17_22-46-41.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_sm__photo2_2021-08-17_22-46-41.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_md__photo2_2021-08-17_22-46-41.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_lg__photo2_2021-08-17_22-46-41.jpg',
                photoThreeExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_xs__photo3_2021-08-17_22-46-50.jpg',
                photoThreeSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_sm__photo3_2021-08-17_22-46-50.jpg',
                photoThreeMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_md__photo3_2021-08-17_22-46-50.jpg',
                photoThreeLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_lg__photo3_2021-08-17_22-46-50.jpg',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58599,
                externalSku: 118301,
                slug: 'boston-sword-tuna-salmon-tails-atlantic-12-oz',
                brand: 'Boston Sword & Tuna',
                name: 'Salmon Tails, Atlantic, 12 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: 0,
                desc: 'Atlantic Salmon is sustainably farmed in low-density, open-water enclosures that protect wild fish stock. They are fed an all natural diet and never given antibiotics or hormones.\n\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.',
                ingredients: 'Salmon. May Contain Bones.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 5.99,
                price: 5.09,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Fish',
                crossAllergens: '',
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_80162023-09-19_13-31-24.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8016_xs_2023-09-19_13-31-00.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8016_sm_2023-09-19_13-31-00.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8016_md_2023-09-19_13-31-00.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8016_lg_2023-09-19_13-31-00.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 63201,
                externalSku: 118609,
                slug: 'frontiere-natural-meats-wagyu-beef-patties-16-oz-1-lb',
                brand: 'Fronti\u00e8re Natural Meats',
                name: 'Wagyu Beef Patties, 16 Oz (1 Lb)',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: 0,
                desc: 'Frontiere Natural Meats has been raising natural and organic beef and other meats for more than 25 years. Its American Wagyu is a unique blend of Japanese Wagyu bred carefully with Angus and Charolais to maintain over 50% Japanese ancestry. This wagyu beef burger has a 80/20 lean/fat ratio for a juicy and decadent patty, clocking in at a third of a pound. Try it on the grill, or griddle it up in a cast-iron skillet.\n\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature, reach out to our customer care team.',
                ingredients: 'Beef.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 9.99,
                price: 8.49,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_83542024-01-03_12-46-10.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8354_xs_2024-01-03_12-45-49.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8354_sm_2024-01-03_12-45-49.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8354_md_2024-01-03_12-45-49.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8354_lg_2024-01-03_12-45-49.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 64064,
                externalSku: 114694,
                slug: 'mission-driven-meat-seafood-chicken-thighs-antibiotic-free-boneless-skinless-14-oz',
                brand: 'Mission Driven Meat & Seafood',
                name: 'Chicken Thighs, Antibiotic-Free Boneless Skinless, 14 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: 0,
                desc: 'These  boneless, skinless chicken thighs tend to be moister and slightly more flavorful than white breast meat due to their higher fat content. Try them braised, baked, or pan-fried.\r\n\r\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.',
                ingredients: 'Chicken, May Contain Up To 3% Retained Water.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 5.49,
                price: 4.69,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_4064_xs_2021-12-14_19-29-03.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4064_sm_2021-12-14_19-29-03.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4064_md_2021-12-14_19-29-03.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4064_lg_2021-12-14_19-29-03.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58868,
                externalSku: 117824,
                slug: 'cream-co-regeneratively-raised-boneless-ribeye-steak-12-oz',
                brand: 'Cream Co',
                name: 'Regeneratively Raised Boneless Ribeye Steak, 12 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Cream Co.\u2019s pasture-raised beef is humanely raised on family-owned ranches using sustainable and regenerative farming practices. Their boneless ribeye is grass fed and barley finished and given no hormones or antibiotics. With coarse grain marbled meat and fine grain ribeye, this is one of the richest cuts on the animal. You'd be hard pressed to find a better steak than this.\n\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.",
                ingredients: '100% West Coast Beef.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 26.99,
                price: 17.19,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: 'Excess inventory',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7502_xs_2023-04-12_10-57-20.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7502_sm_2023-04-12_10-57-20.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7502_md_2023-04-12_10-57-20.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7502_lg_2023-04-12_10-57-20.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 64057,
                externalSku: 117632,
                slug: 'mission-driven-meat-seafood-chicken-breast-diced-14-oz',
                brand: 'Mission Driven Meat & Seafood',
                name: 'Chicken Breast, Diced, 14 Oz',
                coldPacked: true,
                daysAfterOpening: 7,
                daysAfterThaw: 7,
                desc: "Nothing to see here besides pre-diced,  antibiotic-free chicken breast pieces. All you've gotta do is decide how you wanna cook 'em!\r\n\r\nDisclaimer: Your meat and seafood will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.",
                ingredients: 'Chicken Breast with Rib Meat. May contain up to 7% Retained Water.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat & Seafood',
                hasMsrp: true,
                msrp: 5.49,
                price: 4.69,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition: '',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7306_xs_2023-09-21_10-11-28.jpeg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7306_sm_2023-09-21_10-11-28.jpeg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7306_md_2023-09-21_10-11-28.jpeg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7306_lg_2023-09-21_10-11-28.jpeg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
    {
        id: 3,
        name: 'Dairy & Deli',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/dairy-and-deli.svg',
        externalSkus: [117083, 117310, 117160, 114398, 118148, 116736],
        aisleFooter: 'misfit-types',

        items: [
            {
                id: 61545,
                externalSku: 117083,
                slug: 'vital-farms-pasture-raised-small-eggs-1-dz',
                brand: 'Vital Farms',
                name: 'Pasture-Raised Small Eggs, 1 Dz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Vital Farms is on a mission to bring ethically produced pasture-raised foods to the table. Their products are made from pasture-raised hens who have freedom to roam and forage through at least 108 square feet of pasture with plenty of fresh air and sunshine year-round. While their small eggs are not seen as often at the grocery store, they are raised to the ethical standards that people know and trust from the Vital Farms brand.  A hen\u2019s age is the main factor that determines egg size. Young hens tend to produce smaller eggs. The eggs get larger as the hens grow older. But don\u2019t let the size fool you! Vital Farms' pasture-raised small eggs are perfect for your morning scramble, afternoon snack, or however else you like to enjoy your ethically produced eggs!",
                ingredients: 'Shell Eggs.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 5.49,
                price: 4.19,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Eggs',
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Vegetarian'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_67322023-01-12_11-36-20.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6732_xs_2023-09-20_12-08-24.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6732_sm_2023-09-20_12-08-24.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6732_md_2023-09-20_12-08-24.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6732_lg_2023-09-20_12-08-24.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60153,
                externalSku: 117310,
                slug: 'neutral-carbon-neutral-organic-whole-milk-64-fl-oz',
                brand: 'Neutral',
                name: 'Carbon Neutral Organic Whole Milk, 64 Fl Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Finally, milk that's good for you and the planet! Neutral Organic Milk is delicious, organic, carbon neutral, and sourced from pasture-raised cows on small farms..",
                ingredients: 'Organic Grade A Milk, Vitamin D3.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 5.99,
                price: 5.49,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk',
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Non-GMO', 'Organic'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_69592023-02-13_22-02-02.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6959_xs_2023-11-10_16-23-02.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6959_sm_2023-11-10_16-23-02.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6959_md_2023-11-10_16-23-02.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6959_lg_2023-11-10_16-23-02.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 63448,
                externalSku: 117160,
                slug: 'imperfect-foods-grade-aa-salted-butter-1-lb',
                brand: 'Imperfect Foods',
                name: 'Grade AA Salted Butter, 1 Lb',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "If you've ever wondered which butter is better\u2014salted or unsalted\u2014it all depends on what you're using it for. Salt makes things taste better. That's why we'll be spreading this Grade AA Salted Butter all over our toast and pancakes. Salt is also a natural preservative, making salted butter the better butter if you're planning on keeping it in your fridge for a shockingly long time. This butter is rBGH/rBST free.",
                ingredients: 'Cream, Salt.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 5.78,
                price: 4.79,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk',
                crossAllergens: null,
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_68092023-01-09_13-27-47.JPG',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6809_xs_2023-12-20_10-02-03.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6809_sm_2023-12-20_10-02-03.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6809_md_2023-12-20_10-02-03.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6809_lg_2023-12-20_10-02-03.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 62488,
                externalSku: 114398,
                slug: 'belgioioso-sliced-fresh-mozzarella-16-oz-1-lb',
                brand: 'BelGioioso',
                name: 'Sliced Fresh Mozzarella, 16 Oz (1 Lb)',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Since 1979, BelGioioso has been using high-quality Wisconsin milk to make an array of aged and fresh specialty cheeses. This fresh mozzarella log has a delicate, clean taste and comes conveniently pre-sliced in even pieces. Have this log on hand for saving a step while building caprese salads, Margherita pizzas, eggplant or chicken Parmesan, and more.',
                ingredients: 'Pasteurized Milk, Vinegar, Enzymes, Salt.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 8.49,
                price: 6.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk',
                crossAllergens: '',
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_37012021-11-09_20-23-13.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3701_xs_2024-01-17_11-04-18.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3701_sm_2024-01-17_11-04-18.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3701_md_2024-01-17_11-04-18.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3701_lg_2024-01-17_11-04-18.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 64568,
                externalSku: 118148,
                slug: 'petit-pot-misfits-market-upcycled-rice-pudding-8-oz',
                brand: 'Petit Pot + Misfits Market',
                name: 'Upcycled Rice Pudding, 8 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "We teamed up with Petit Pot to  create a creamy rice pudding with a sustainable spin that you'll only find on our storefront. Each (reusable glass) jar of pudding maintains the same quality and flavor you expect from Petit Pot with an added plus: it's made with upcycled rice that would've otherwise become animal feed. By choosing this one-of-a-kind dessert, you\u2019re helping us fight food waste, one tasty treat a time.",
                ingredients:
                    'Whole Milk, Heavy Cream, Broken Rice, Organic Cane Sugar, Vanilla Extract, Sea Salt, Vanilla Bean Seed.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 5.99,
                price: 4.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk',
                crossAllergens: 'May Contain: Coconut, Eggs, Hazelnut, Pistachio',
                attributes: [],
                sourcingReason: 'Upcycled',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_78502023-09-20_15-27-53.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7850_xs_2023-09-20_15-27-38.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7850_sm_2023-09-20_15-27-38.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7850_md_2023-09-20_15-27-38.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7850_lg_2023-09-20_15-27-38.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 59423,
                externalSku: 116736,
                slug: 'imperfect-foods-grass-fed-whole-milk-greek-yogurt-16-oz',
                brand: 'Imperfect Foods',
                name: 'Grass-Fed Whole Milk Greek Yogurt, 16 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Notice something different? This whole milk Greek yogurt is now part of the Odds & Ends family and has a new look! We didn\u2019t want any of the previous containers to go to waste, so in true Misfits fashion, we\u2019re continuing to use the remaining\u00a0tubs printed with the now-vintage Imperfect Foods design until our stash runs out. If your product arrives in the old packaging, don\u2019t worry\u2014the yogurt inside is as fresh as ever! This smooth & tangy whole milk Greek yogurt is made with milk from grass-fed cows that's leftover from the butter-making process. It makes a delicious canvas for all of your favorite accompaniments, from granola and sliced fresh fruit to toasted nuts and a drizzle of honey.",
                ingredients:
                    'Grade A Pasteurized Whole Milk, Cream, Live Active Cultures Cultured After Pasteurization.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy',
                hasMsrp: true,
                msrp: 3.89,
                price: 2.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk',
                crossAllergens: null,
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_63822023-01-09_20-17-10.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6382_xs_2023-09-20_21-03-47.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6382_sm_2023-09-20_21-03-47.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6382_md_2023-09-20_21-03-47.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6382_lg_2023-09-20_21-03-47.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
    {
        id: 4,
        name: 'Bakery & Pantry',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/bakery-and-pantry.svg',
        externalSkus: [114476, 116124, 116412, 118507, 116815, 117445],
        aisleFooter: 'our-brands',

        items: [
            {
                id: 59672,
                externalSku: 114476,
                slug: 'king-arthur-buttermilk-pancake-mix-16-oz-1-lb',
                brand: 'King Arthur',
                name: 'Buttermilk Pancake Mix, 16 Oz (1 Lb)',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'King Arthur Baking Company has been making quality baking essentials since 1790. This Buttermilk Pancake Mix is made with unbleached wheat flour, real buttermilk, sunflower oil, baking soda, and a touch of both cane and brown sugars to yield pancakes that are creamy and fluffy with a hint of sweetness. Whether you like your pancakes plain and simple or with add-ins (chocolate chips or blueberries, anyone?), this mix is a delicious way to start the day.',
                ingredients:
                    'King Arthur Unbleached Flour (Wheat Flour, Malted Barley Flour), Sunflower Oil, Buttermilk, Cane Sugar, Brown Sugar, Baking Powder (Baking Soda, Calcium Acid Pyrophosphate, Monocalcium Phosphate), Natural Flavor, Sea Salt, Wheat Protein.',
                isDrinksItem: false,
                l1TaxonomyName: 'Breakfast',
                hasMsrp: true,
                msrp: 5.99,
                price: 4.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk, Wheat',
                crossAllergens: '',
                attributes: ['Kosher', 'Non-GMO'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_37932021-11-02_19-26-21.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_xs_2021-11-02_19-26-09.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_sm_2021-11-02_19-26-09.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_md_2021-11-02_19-26-09.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_lg_2021-11-02_19-26-09.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_xs__photo2_2021-11-05_14-34-01.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_sm__photo2_2021-11-05_14-34-01.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_md__photo2_2021-11-05_14-34-01.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_lg__photo2_2021-11-05_14-34-01.jpg',
                photoThreeExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_xs__photo3_2021-11-05_14-34-29.jpg',
                photoThreeSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_sm__photo3_2021-11-05_14-34-29.jpg',
                photoThreeMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_md__photo3_2021-11-05_14-34-29.jpg',
                photoThreeLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3793_lg__photo3_2021-11-05_14-34-29.jpg',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60289,
                externalSku: 116124,
                slug: 'odds-ends-organic-creamy-peanut-butter-salted-16-oz-1-lb',
                brand: 'Odds & Ends',
                name: 'Organic Creamy Peanut Butter, Salted, 16 Oz (1 Lb)',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "At Misfits Market, we believe everyone deserves access to affordable, high-quality food. That's why we created Odds & Ends, to make it easier to stock up on essentials at prices you'll love. Our creamy peanut butter is all about simplicity: organic roasted peanuts, flaky sea salt, and nothing else. What comes next is up to you\u2014whether that means swirling it into your morning oatmeal, spreading it in a sandwich with banana slices, or eating it straight from the jar.",
                ingredients: 'Organic Roasted Peanuts, Sea Salt.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dry Pantry',
                hasMsrp: true,
                msrp: 6.99,
                price: 4.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Peanuts',
                crossAllergens: '',
                attributes: ['Organic'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_57102022-11-15_12-47-29.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_xs_2022-11-15_12-46-17.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_sm_2022-11-15_12-46-17.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_md_2022-11-15_12-46-17.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_lg_2022-11-15_12-46-17.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_xs__photo2_2022-11-15_12-46-30.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_sm__photo2_2022-11-15_12-46-30.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_md__photo2_2022-11-15_12-46-30.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_lg__photo2_2022-11-15_12-46-30.jpg',
                photoThreeExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_xs__photo3_2022-11-15_12-46-38.jpg',
                photoThreeSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_sm__photo3_2022-11-15_12-46-38.jpg',
                photoThreeMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_md__photo3_2022-11-15_12-46-38.jpg',
                photoThreeLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_lg__photo3_2022-11-15_12-46-38.jpg',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58743,
                externalSku: 116412,
                slug: 'cento-all-in-one-crushed-tomatoes-28-oz',
                brand: 'Cento',
                name: 'All-In-One Crushed Tomatoes, 28 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Cento All-in-One Crushed Tomatoes consist of peeled, ground crushed tomatoes fresh-packed in pur\u00e9e. Random-cut and chunky, these tomatoes are perfect for your favorite chili recipe or a quick marinara. [Description provided by Cento.]',
                ingredients: 'Vine Ripened Tomatoes, Tomato Puree, Sea Salt, Naturally Derived Citric Acid.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dry Pantry',
                hasMsrp: true,
                msrp: 2.99,
                price: 2.59,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: ['Kosher'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_60322022-10-19_11-12-24.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6032_xs_2022-10-18_22-01-18.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6032_sm_2022-10-18_22-01-18.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6032_md_2022-10-18_22-01-18.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6032_lg_2022-10-18_22-01-18.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58709,
                externalSku: 118507,
                slug: 'cascadian-farm-organic-cinnamon-crunch-cereal-92-oz',
                brand: 'Cascadian Farm',
                name: 'Organic Cinnamon Crunch Cereal, 9.2 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Cascadian Farm loves wholesome, organic ingredients perfected by Mother Nature and supports farmers who use sustainable practices to regenerate the land and their communities. Featuring organic whole-grain squares lightly sprinkled with cinnamon and sugar, this hearty graham cereal tastes delicious whether served with milk or by the handful for an on-the-go snack. [Description provided by Cascadian Farm.]',
                ingredients:
                    'Whole Grain Wheat*, Cane Sugar*, Rice Flour*, Sunflower Oil*, Oat Fiber*, Maltodextrin*, Cinnamon*, Sea Salt, Dextrose*. Vitamin E (Mixed Tocopherols) Added To Preserve Freshness.\n\n*Organic.',
                isDrinksItem: false,
                l1TaxonomyName: 'Breakfast',
                hasMsrp: true,
                msrp: 6.49,
                price: 5.49,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Wheat',
                crossAllergens: 'May Contain: Soybean',
                attributes: ['Non-GMO', 'Organic'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_82472023-11-05_20-36-12.jpeg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8247_xs_2023-11-15_14-55-32.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8247_sm_2023-11-15_14-55-32.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8247_md_2023-11-15_14-55-32.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8247_lg_2023-11-15_14-55-32.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 58745,
                externalSku: 116815,
                slug: 'cento-black-beans-155-oz',
                brand: 'Cento',
                name: 'Black Beans, 15.5 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Cento Black Beans are the perfect healthy addition to your favorite soup, salad or chili recipe. Delicious while also being nutritious, black beans are gluten-free and a great source of protein, essential vitamins and minerals with little fat.',
                ingredients: 'Prepared Black Beans, Water, Salt, Calcium Chloride.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dry Pantry',
                hasMsrp: true,
                msrp: 1.99,
                price: 1.69,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Major Allergen Free', 'Non-GMO', 'Plant-Based', 'Vegan', 'Vegetarian'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_64612023-01-09_09-54-39.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6461_xs_2023-09-19_19-27-15.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6461_sm_2023-09-19_19-27-15.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6461_md_2023-09-19_19-27-15.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6461_lg_2023-09-19_19-27-15.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60317,
                externalSku: 117445,
                slug: 'odds-ends-us-grown-broken-white-jasmine-rice-32-oz',
                brand: 'Odds & Ends',
                name: 'U.S. Grown Broken White Jasmine Rice, 32 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'We created Odds & Ends to make it easier to get high-quality food at a great value and support a more sustainable food system, one bite at a time. (Not-so) fun fact: There are official limits around how many broken kernels a crop can contain (4% to be exact). Any more than that and a crop is deemed unsellable by traditional grocery stores and gets marked as animal feed\u2014simply due to a few more cracked kernels! That\u2019s why we partner with U.S. growers to rescue rice that goes over this 4% limit, because when it has the same great taste and texture, who minds a partial kernel here and there? By choosing Odds & Ends Barely Broken White Jasmine Rice, you\u2019re helping us fight food waste with every rice bowl, pilaf, or stir-fry you cook up.',
                ingredients: 'White Jasmine Rice.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dry Pantry',
                hasMsrp: true,
                msrp: 7.99,
                price: 5.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: ['Gluten-Free', 'Non-GMO', 'Plant-Based', 'Vegan', 'Vegetarian'],
                sourcingReason: 'Slightly Imperfect',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_71032024-02-05_10-04-13.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7103_xs_2024-02-05_10-03-40.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7103_sm_2024-02-05_10-03-40.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7103_md_2024-02-05_10-03-40.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7103_lg_2024-02-05_10-03-40.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
    {
        id: 5,
        name: 'Snacks & Beverages',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/snacks-and-beverages.svg',
        externalSkus: [118339, 114449, 112674, 116665, 118157, 117113],
        aisleFooter: 'impact',

        items: [
            {
                id: 59830,
                externalSku: 118339,
                slug: 'liquid-death-sparkling-mountain-water-100-naturally-flavored-mango-chainsaw-16-fl-oz',
                brand: 'Liquid Death',
                name: 'Sparkling Mountain Water, 100% Naturally Flavored, Mango Chainsaw, 16 Fl Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "What makes this sparkling water a misfit? Liquid Death recently tweaked both the size and packing configuration of its cans in order to ship them more efficiently, so we were able to score a remainder of the cans in the outdated size at a killer price. This fizzy, mango-essenced water looks like a beer and is carbonated like a beer, but isn't actually one at all! Made with 100% ice-cold mountain water, natural fruit extracts, and a touch of agave nectar, this sparkling water has a lighter level of carbonation (5 grams/L) similar to most beers and is more drinkable than that of most sodas (6-8 grams/L). Delicately bubbly and refreshing, this canned sparkling water is best enjoyed chilled.",
                ingredients:
                    'Carbonated Mountain Water, Agave Nectar, Natural Mango Flavor, Citric Acid, Orange Extract, Natural Flavor.',
                isDrinksItem: false,
                l1TaxonomyName: 'Beverages',
                hasMsrp: true,
                msrp: 1.99,
                price: 1.29,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: 'Packaging Change',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_80572023-10-10_11-42-21.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8057_xs_2023-10-10_11-41-24.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8057_sm_2023-10-10_11-41-24.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8057_md_2023-10-10_11-41-24.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8057_lg_2023-10-10_11-41-24.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60293,
                externalSku: 114449,
                slug: 'odds-ends-organic-dried-mango-slices-8-oz',
                brand: 'Odds & Ends',
                name: 'Organic Dried Mango Slices, 8 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'At Misfits Market we believe everyone deserves access to affordable, high-quality food\u2014that\u2019s why we created Odds & Ends, to make it easier to stock up on essentials at prices you\u2019ll love. These organic dried mango slices are made without added sugars and come in a resealable bag to preserve their freshness. While these slices are a tasty snack on their own (we like to think of them as being nature\u2019s take on fruit leather!), they\u2019re also great for making homemade chutney or even adding to cocktails, especially spicy ones.',
                ingredients: 'Organic Mango.',
                isDrinksItem: false,
                l1TaxonomyName: 'Snacks & Candy',
                hasMsrp: true,
                msrp: 11.99,
                price: 6.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: ['Kosher', 'Organic', 'Vegan'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_37572022-04-07_17-43-45.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_3757_xs_2023-09-21_16-54-05.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3757_sm_2023-09-21_16-54-05.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3757_md_2023-09-21_16-54-05.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3757_lg_2023-09-21_16-54-05.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 61487,
                externalSku: 112674,
                slug: 'uglies-kettle-chips-original-sea-salt-6-oz',
                brand: 'Uglies',
                name: 'Kettle Chips, Original Sea Salt, 6 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Uglies has rescued over 4.2 million pounds of potatoes since 2017 by crafting their chips from potatoes with minor imperfections that would have otherwise gone to waste. These kettle-cooked chips have a satisfying crunch and are simply seasoned with sea salt.',
                ingredients: 'Potatoes, Sunflower Oil, Salt.',
                isDrinksItem: false,
                l1TaxonomyName: 'Snacks & Candy',
                hasMsrp: true,
                msrp: 3.99,
                price: 3.51,
                priceSensitive: false,
                prop65: true,
                prop65Category: 'Food Products',
                prop65Ingredients: 'Acrylamide',
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: ['Gluten-Free', 'Kosher', 'Non-GMO'],
                sourcingReason: 'Upcycled',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_16022021-03-22_12-26-23.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_1602_xs_2024-02-02_10-28-06.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_1602_sm_2024-02-02_10-28-06.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_1602_md_2024-02-02_10-28-06.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_1602_lg_2024-02-02_10-28-06.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 59405,
                externalSku: 116665,
                slug: 'imperfect-foods-cold-pressed-orange-juice-32-fl-oz-1-qt',
                brand: 'Imperfect Foods',
                name: 'Cold Pressed Orange Juice, 32 Fl Oz (1 Qt)',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'At Misfits Market we believe everyone deserves access to affordable, high-quality food\u2014that\u2019s why we created Odds & Ends, to make it easier to stock up on essentials at prices you\u2019ll love. Juicing is a timeless answer to the question of what to do with not-quite-perfect-looking oranges that traditional grocery stores pass up and would otherwise be destined for the landfill. This juice is made from oranges that are picked at peak ripeness, then cold-pressed to preserve both sweet, vibrant flavor as well as vitamins and minerals. Better yet, the excess pulp gets added to dairy farm feed, and the peels are pressed to extract their aromatic oils.',
                ingredients: '100% Orange Juice.',
                isDrinksItem: false,
                l1TaxonomyName: 'Beverages',
                hasMsrp: true,
                msrp: 7.99,
                price: 5.29,
                priceSensitive: false,
                prop65: true,
                prop65Category: 'Canned and bottled food',
                prop65Ingredients: '',
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Non-GMO', 'Vegetarian'],
                sourcingReason: 'Slightly Imperfect',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_63112023-01-09_13-27-06.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6311_xs_2022-12-23_11-02-29.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6311_sm_2022-12-23_11-02-29.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6311_md_2022-12-23_11-02-29.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6311_lg_2022-12-23_11-02-29.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60348,
                externalSku: 118157,
                slug: 'olipop-sparkling-tonic-root-beer-12-fl-oz-4-ct',
                brand: 'Olipop',
                name: 'Sparkling Tonic, Root Beer, 12 Fl Oz (4 Ct)',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Olipop's botanically driven Root Beer marries a classic bite with a creamy sweetness with extracts of sweet birch, smooth-vanilla bean and naturally sourced burdock root. We recommend pairing it with your favorite ice-cream. Each can contains 9g dietary fiber, only 2g of sugar, and just 35 calories.",
                ingredients:
                    'Carbonated Water, Olismart (Cassava Root Fiber, Chicory Root Inulin, Jerusalem Artichoke Inulin, Nopal Cactus*, Calendula Flower*, Kudzu Root*, Marshmallow Root*, Slippery Elm Bark*), Cassava Root Syrup, Apple Juice Concentrate, Organic Natural Root Beer Flavor, Lemon Juice, Burdock Root*, Stevia Leaf*, Himalayan Pink Salt, Natural Vanilla Flavor*, Sweet Birch*. *Extract.',
                isDrinksItem: false,
                l1TaxonomyName: 'Beverages',
                hasMsrp: true,
                msrp: 9.99,
                price: 7.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: [],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_78592023-08-09_09-25-50.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_xs_2023-09-21_17-23-44.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_sm_2023-09-21_17-23-44.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_md_2023-09-21_17-23-44.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_lg_2023-09-21_17-23-44.jpg',
                photoTwoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_xs__photo2_2023-09-01_11-22-26.jpg',
                photoTwoSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_sm__photo2_2023-09-01_11-22-26.jpg',
                photoTwoMed:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_md__photo2_2023-09-01_11-22-26.jpg',
                photoTwoLarge:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_lg__photo2_2023-09-01_11-22-26.jpg',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 59414,
                externalSku: 117113,
                slug: 'imperfect-foods-dark-chocolate-covered-pretzel-pieces-12-oz',
                brand: 'Imperfect Foods',
                name: 'Dark Chocolate Covered Pretzel Pieces, 12 Oz',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "In the process of coating pretzels in delicious dark chocolate, a good portion of them are broken. These broken pretzel pieces and parts often end up going to waste because they aren't as aesthetically pleasing as a whole pretzel. But as it turns out, a smaller, broken pretzel covered in dark-chocolate achieves the perfect golden ratio of salty and sweet, making our broken Dark Chocolate Covered Pretzels even more delicious than the original. If ever there was a snack to feel good about, it's this one.",
                ingredients:
                    'Dark Chocolate (Sugar, Chocolate Liquor [Processed With Alkali], Cocoa Butter, Milk Fat, Soy Lecithin [An Emulsifier], Vanilla Extract), Pretzels* (Unbleached Enriched Wheat Flour [Wheat Flour, Niacin, Iron, Thiamine Mononitrate, Riboflavin {Vitamin B2}, Folic Acid], Malted Barley Flour, Salt, Soybean Oil). *Upcycled Ingredients',
                isDrinksItem: false,
                l1TaxonomyName: 'Snacks & Candy',
                hasMsrp: true,
                msrp: 6.59,
                price: 4.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Milk, Soybean, Wheat',
                crossAllergens: 'May Contain: Almond, Cashew, Coconut, Eggs, Peanuts, Pecan',
                attributes: ['Vegetarian'],
                sourcingReason: 'Upcycled',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_67622023-01-05_12-01-34.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6762_xs_2023-09-20_12-55-32.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6762_sm_2023-09-20_12-55-32.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6762_md_2023-09-20_12-55-32.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6762_lg_2023-09-20_12-55-32.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
    {
        id: 6,
        name: 'Plant-Based',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/plant-based.svg',
        externalSkus: [115095, 118557, 116762, 118702, 115495, 116757],
        aisleFooter: 'testimonials',

        items: [
            {
                id: 59325,
                externalSku: 115095,
                slug: 'hodo-organic-tofu-extra-firm-10-oz',
                brand: 'Hodo',
                name: 'Organic Tofu, Extra Firm, 10 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Hodo makes plant-based foods that are flavor-forward, thoughtfully sourced, and minimally processed. This Organic Firm Tofu is nutty and complex in flavor and is crafted from higher-protein soy milk and using traditional methods. This tofu comes ready for oven-roasting with a simple salt-and-pepper seasoning, stir-frying with veggies and your favorite sauces, or dicing and serving fresh in salads.',
                ingredients: 'Water, Organic Soybeans, Calcium Sulfate.',
                isDrinksItem: false,
                l1TaxonomyName: 'Meat Alternatives',
                hasMsrp: true,
                msrp: 4.49,
                price: 4.49,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Soybean',
                crossAllergens: '',
                attributes: ['Gluten-Free', 'Organic', 'Vegan'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_45512022-03-22_21-03-54.jpeg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_4551_xs_2022-03-22_21-03-29.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4551_sm_2022-03-22_21-03-29.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4551_md_2022-03-22_21-03-29.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4551_lg_2022-03-22_21-03-29.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 59297,
                externalSku: 118557,
                slug: 'harmless-harvest-organic-coconut-yogurt-plain-unsweetened-24-oz',
                brand: 'Harmless Harvest',
                name: 'Organic Coconut Yogurt, Plain Unsweetened, 24 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Dairy-free anything can be a tough nut to crack. Good thing we've got some experience with that! To make our plant-based yogurt, we start with hand-scooped organic coconut meat, pur\u00e9e it until perfectly smooth, then add a handful of tasty supporting ingredients. And we do it all without dairy or any artificial stuff. [Description provided by Harmless Harvest.]",
                ingredients:
                    'Organic Coconut Milk (Water, Organic Coconut Meat*), Organic Tapioca Starch, Live And Active Cultures, *Fair Trade Certified According To The Fair For Life Standard: 92% Of The Total Ingredients.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy Alternatives',
                hasMsrp: true,
                msrp: 7.99,
                price: 6.79,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Coconut',
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Organic', 'Plant-Based', 'Upcycled Certified', 'Vegan', 'Vegetarian'],
                sourcingReason: 'Upcycled',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_83012023-11-17_19-54-19.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8301_xs_2023-11-17_19-54-31.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8301_sm_2023-11-17_19-54-31.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8301_md_2023-11-17_19-54-31.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8301_lg_2023-11-17_19-54-31.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 59575,
                externalSku: 116762,
                slug: 'just-egg-plant-based-folded-egg-8-oz',
                brand: 'JUST Egg',
                name: 'Plant-Based Folded Egg, 8 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'JUST Egg Folded makes breakfast practically unskippable. Simply pop it in a toaster, microwave, oven or skillet, and some really good eggs will be on your plate in minutes.Store in freezer.Disclaimer: This item will arrive alongside your other groceries inside an insulated liner with an ice pack, it will likely thaw a little during transit. It is safe to refreeze if needed after thawed. It should arrive at refrigerator temp or colder, but if you feel uncertain about the temperature reach out to our customer care team.',
                ingredients:
                    'Water, Mung Bean Protein Isolate,  Expeller-Pressed Canola Oil, Corn Starch, Contains Less Than 2% Of Baking Powder (Sodium Acid Pyrophosphate, Sodium Bicarbonate, Corn Starch, Monocalcium Phosphate), Dehydrated Garlic, Dehydrated Onion, Carrot Extractives (Color), Turmeric Extractives (Color), Salt, Transglutaminase.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy Alternatives',
                hasMsrp: true,
                msrp: 5.99,
                price: 5.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: '',
                attributes: ['Keto-Friendly', 'Non-GMO', 'Plant-Based', 'Vegan', 'Vegetarian'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_64082023-01-10_11-04-22.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6408_xs_2022-12-23_15-18-21.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6408_sm_2022-12-23_15-18-21.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6408_md_2022-12-23_15-18-21.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6408_lg_2022-12-23_15-18-21.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 63261,
                externalSku: 118702,
                slug: 'good-planet-foods-olive-oil-cheese-shreds-mozzarella-7-oz',
                brand: 'Good Planet Foods',
                name: 'Olive Oil Cheese Shreds, Mozzarella, 7 Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'Our easy to melt Olive Oil Mozzarella Shreds are ideal for your pizzas, pastas, and so much more. [Description provided by Good Planet Foods].',
                ingredients:
                    'Filtered Water, Olive Oil, Potato Starch, Tapioca Starch, Faba Protein, Natural Flavors (Vegan Sources), Sea Salt, Calcium Citrate, Dextrose, Carob Bean Gum, Xanthan Gum, Annatto And Turmeric Extracts (Color), Powdered Cellulose Added To Prevent Caking.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy Alternatives',
                hasMsrp: true,
                msrp: 5.99,
                price: 5.99,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: null,
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Non-GMO', 'Plant-Based', 'Vegan', 'Vegetarian'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_84492024-01-09_10-57-57.png',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_8449_xs_2024-01-09_10-57-41.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8449_sm_2024-01-09_10-57-41.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8449_md_2024-01-09_10-57-41.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8449_lg_2024-01-09_10-57-41.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 60015,
                externalSku: 115495,
                slug: 'minor-figures-organic-oat-milk-32-fl-oz-1-qt',
                brand: 'Minor Figures',
                name: 'Organic Oat Milk, 32 Fl Oz (1 Qt)',
                coldPacked: false,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: "Minor Figures is made by specialty coffee pros obsessed with creating the perfect dairy-free alternative to coffee creamer. This organic Oat Milk is naturally sweet, thick, and creates a silky foam when steamed. It's also great with tea, or your morning granola. Vegan. Dairy free.",
                ingredients: 'Organic Oat Syrup, High Oleic Organic Sunflower Oil, Salt, Potassium Carbonate.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy Alternatives',
                hasMsrp: true,
                msrp: 4.99,
                price: 4.49,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: '',
                crossAllergens: 'May Contain: Wheat',
                attributes: ['Certified B Corporation', 'Organic'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_50342023-08-23_11-39-25.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_5034_xs_2023-08-23_11-38-30.jpg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5034_sm_2023-08-23_11-38-30.jpg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5034_md_2023-08-23_11-38-30.jpg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5034_lg_2023-08-23_11-38-30.jpg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-19 16:00:02.073677',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
            {
                id: 62692,
                externalSku: 116757,
                slug: 'califia-farms-unsweetened-almond-milk-48-fl-oz',
                brand: 'Califia Farms',
                name: 'Unsweetened Almond Milk, 48 Fl Oz',
                coldPacked: true,
                daysAfterOpening: null,
                daysAfterThaw: null,
                desc: 'The smooth creaminess of our Unsweetened Almondmilk is yours, with 0 grams of sugar and only 35 calories per serving. Packed with calcium, it fits right in at breakfast. Use it in recipes that call for milk, from soups and sauces to cakes and smoothies. [Description provided by Califia.]',
                ingredients:
                    'Almondmilk (Water, Almonds), Calcium Carbonate, Sunflower Lecithin, Sea Salt, Natural Flavor, Guar Gum, Gellan Gum, Potassium Citrate.',
                isDrinksItem: false,
                l1TaxonomyName: 'Dairy Alternatives',
                hasMsrp: true,
                msrp: 4.99,
                price: 3.69,
                priceSensitive: false,
                prop65: false,
                prop65Category: '',
                prop65Ingredients: null,
                taxCode: '40030',
                allergens: 'Contains: Almond',
                crossAllergens: null,
                attributes: ['Gluten-Free', 'Non-GMO', 'Plant-Based', 'Vegetarian'],
                sourcingReason: '',
                portion: 1,
                photoNutrition:
                    'https://img-cdn.misfitsmarket.com/item_images/item_nutrition_64032023-01-06_16-32-17.jpg',
                photoExtraSmall:
                    'https://img-cdn.misfitsmarket.com/item_images/item_info_6403_xs_2023-09-20_16-00-32.jpeg',
                photoSmall: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6403_sm_2023-09-20_16-00-32.jpeg',
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6403_md_2023-09-20_16-00-32.jpeg',
                photoLarge: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6403_lg_2023-09-20_16-00-32.jpeg',
                photoTwoExtraSmall: '',
                photoTwoSmall: '',
                photoTwoMed: '',
                photoTwoLarge: '',
                photoThreeExtraSmall: '',
                photoThreeSmall: '',
                photoThreeMed: '',
                photoThreeLarge: '',
                photoFourExtraSmall: '',
                photoFourSmall: '',
                photoFourMed: '',
                photoFourLarge: '',
                photoFiveExtraSmall: '',
                photoFiveSmall: '',
                photoFiveMed: '',
                photoFiveLarge: '',
                createdAt: {
                    date: '2024-04-26 16:00:01.603958',
                    timezone_type: 1,
                    timezone: '+00:00',
                },
            },
        ],
    },
];
